import { useCallback } from "react";
import type { AlleOptionen } from "../api";
import { useOptionen } from "../optionen";

export default function OptionLabel<T extends keyof AlleOptionen>({
  typ,
  wert,
}: {
  typ: T;
  wert: string;
}) {
  const getLabel = useGetOptionLabel(typ);

  return <>{getLabel(wert)}</>;
}

export function useGetOptionLabel<T extends keyof AlleOptionen>(
  typ: T
): (wert: string) => string {
  const optionen = useOptionen<T>(typ);

  return useCallback(
    (wert) => optionen.find((o) => o.wert === wert)?.name ?? wert,
    [optionen]
  );
}
